import PropTypes from 'prop-types'
import React, { useState, createContext, useContext } from 'react'

import styles from '../../theme/themes.module.scss'

const themeContext = createContext()

export const useTheme = () => {
  const context = useContext(themeContext)

  const [isDarkmode, setIsDarkmode] = context

  const setDarkmodeOn = () => {
    setIsDarkmode(true)
  }

  const setDarkmodeOff = () => {
    setIsDarkmode(false)
  }

  const toggle = () => {
    setIsDarkmode((prev) => !prev)
  }

  return { isDarkmode, setDarkmodeOn, setDarkmodeOff, toggle }
}

export const ThemeProvider = (props) => {
  const [isDarkmode, setIsDarkmode] = useState(false)
  const theme = isDarkmode ? styles.darkTheme : styles.defaultTheme

  return (
    <themeContext.Provider value={[isDarkmode, setIsDarkmode]}>
      <div
        className={theme}
        data-testid="auto-id-8d0ec353-e25d-40e1-987d-484ef0ab0795"
      >
        {props.children}
      </div>
    </themeContext.Provider>
  )
}

ThemeProvider.propTypes = {
  children: PropTypes.node,
}

export default ThemeProvider
